export default function () {
  return [
    {
      label: '首页',
      name: 'homePage',
      firstView: 'homePage'
    },
    {
      label: '青团之声',
      name: 'newHomeIndex',
      firstView: 'youth_league_voice'
    },
    {
      label: '创业创新',
      name: 'newHomeIndex',
      firstView: 'pioneer_innovation'
    },
    {
      label: '工会动态',
      name: 'newHomeIndex',
      firstView: 'union_news'
    },
    {
      label: '党建引领',
      name: 'newHomeIndex',
      firstView: 'party_lead'
    },
    {
      label: '廉洁园地',
      name: 'newHomeIndex',
      firstView: 'probity_garden'
    },
    {
      label: '文化阵地',
      name: 'newHomeIndex',
      firstView: 'culture_position'
    },
    {
      label: '榜样力量',
      name: 'newHomeIndex',
      firstView: 'model_strength'
    },
    {
      label: '公益活动',
      name: 'newHomeIndex',
      firstView: 'public_benefit_activities'
    },
    {
      label: '重大新闻',
      name: 'newHomeIndex',
      firstView: 'culture_position'
    },
    {
      label: '管理者思想',
      name: 'newHomeIndex',
      firstView: 'culture_position'
    },
    {
      label: '通知公告',
      name: 'newHomeIndex',
      firstView: 'notice'
    },
    {
      label: 'BEZ微讯',
      name: 'newHomeIndex',
      firstView: 'notice'
    },
  ]
}
